import { Dispatch, FC, SetStateAction } from "react";
import styles from "./ImageGallery.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronLeft } from "@fortawesome/pro-solid-svg-icons";
import { Navigation } from "swiper";
import { Link } from "react-router-dom";
import useWindowSize from "../../../core/hook/windowsize.hook";
import { IMedia } from "@wohnsinn/ws-ts-lib";
import { useNavigate } from "react-router-dom";

export interface IImageGalleryProps {
  media: IMedia[];
  handleSlideTap?: any;
  slideShowIndex: number;
  setSlideShowIndex: Dispatch<SetStateAction<number>>;
  noLightBox?: boolean;
  routerLink?: string;
  reelsView?: boolean;
  id: string;
  onClick?: any;
}

const ImageGallery: FC<IImageGalleryProps> = ({
  media,
  handleSlideTap = null,
  slideShowIndex,
  setSlideShowIndex,
  noLightBox = false,
  reelsView = false,
  routerLink,
  id,
  onClick,
}) => {
  const navigate = useNavigate();
  const { isSmallerSm } = useWindowSize();

  return (
    <>
      <div className={`${styles.swiperWrapper} ${reelsView ? styles.reelsView : ""}`}>
        {routerLink ? <Link className={routerLink ? styles.link : ""} to={routerLink} /> : null}
        {media.length > 1 ? (
          <>
            <button
              className={`M-${id.replaceAll(",", "-").replaceAll(":", "-")}-swiper-prev ${styles.buttons} ${styles.prev}`}
            >
              <span className={"sr-only"}>prev</span>
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <button
              className={`M-${id.replaceAll(",", "-").replaceAll(":", "-")}-swiper-next ${styles.buttons} ${styles.next}`}
            >
              <span className={"sr-only"}>next</span>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </>
        ) : null}
        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: `.M-${id.replaceAll(",", "-").replaceAll(":", "-")}-swiper-next`,
            prevEl: `.M-${id.replaceAll(",", "-").replaceAll(":", "-")}-swiper-prev`,
          }}
          watchSlidesProgress={true}
          allowTouchMove
          tabIndex={0}
          slidesPerView={1}
          spaceBetween={0}
          onSlideChange={(swiper) => setSlideShowIndex(swiper.activeIndex)}
          className={styles.slides}
          onClick={routerLink ? () => navigate(routerLink) : onClick ? onClick : undefined}
        >
          {media.map((media, i) => (
            <SwiperSlide
              onClick={noLightBox ? undefined : () => handleSlideTap(i)}
              key={`${media.id}-${i}`}
              className={styles.slide}
            >
              {reelsView && isSmallerSm ? (
                <img
                  className={styles.image}
                  src={media.uprightUrl ? media.uprightUrl : media.thumbnailUrl ? media.thumbnailUrl : media.url}
                  alt=""
                  loading="lazy"
                />
              ) : (
                <img
                  className={styles.image}
                  src={media.thumbnailUrl ? media.thumbnailUrl : media.url}
                  alt=""
                  loading="lazy"
                />
              )}
            </SwiperSlide>
          ))}
        </Swiper>

        {media.length > 1 ? (
          <div className={styles.indexIndicator}>{`${(
            slideShowIndex + 1
          ).toString()} / ${media.length.toString()}`}</div>
        ) : null}
      </div>
    </>
  );
};

export default ImageGallery;
